import WithRender from "../../templates/imageEditor/cropImage.html";
import { mapGetters } from "vuex";

export default WithRender({
  props: ["item", "index", "active", "unit"],
  computed: {
    ...mapGetters(["getShow", "getReady"]),
    ready: function () {
      return this.getReady;
    },
    baseUrl: function () {
      return this.getConfigProp("baseUrl");
    },
    cropImageSrc: function () {
      return this.item.imageSrc;
    },
    imageChanged: function () {
      return {
        ready: this.ready,
        imageSrc: this.item.imageSrc,
        width: this.item.width,
        height: this.item.height,
        unit: this.unit,
        zoom: this.item.zoom,
        scaleX: this.item.scaleX
      };
    }
  },
  data: function () {
    return {
      cropper: null
    };
  },
  methods: {
    initImageCanvas: function () {
      var $image = jQuery(this.$el).find(">img");
      var parent = $image.parent();
      var cropper = $image.data("cropper");
      var init = false;
      if (!cropper) {
        $image.cropper({
          dragMode: "move",
          toggleDragModeOnDblclick: false,
          cropBoxMovable: false,
          cropBoxResizable: false,
          viewMode: 3,
          autoCrop: true,
          autoCropArea: 1,
          center: false,
          guides: false,
          minContainerWidth: 1,
          minContainerHeight: 1,
          cropstart: function () {
            togglePep("#format-layer", true);
          },
          cropend: function () {
            togglePep("#format-layer", false);
          },
          crop: (function (instance, $image) {
            return function (event) {
              var cropper = $image.data("cropper");
              instance.$store.commit("updateItem", {
                type: "objects",
                index: instance.index,
                props: {
                  canvasData: cropper.getCanvasData(),
                  cropData: cropper.getData()
                }
              });
            };
          })(this, $image),
          ready: (function (instance, $image) {
            return function () {
              var cropper = $image.data("cropper");
              cropper.setCanvasData({ ...instance.item.canvasData });
            };
          })(this, $image)
        });
        init = true;
      }
      return init;
    },
    initNewImage: function (newData, oldData) {
      var $image = jQuery(this.$el).find(">img");
      var parent = $image.parent();
      var init = this.initImageCanvas();
      this.cropper = $image.data("cropper");

      if (this.cropper) {
        if (
          newData.width !== oldData.width ||
          newData.height !== oldData.height ||
          newData.zoom !== oldData.zoom ||
          newData.scaleX !== oldData.scaleX ||
          (newData.unit !== oldData.unit && !init)
        ) {
          this.cropper.resize();
          var canvasData = { ...this.item.canvasData };
          this.cropper.setCanvasData({ ...this.item.canvasData });
          this.cropper.setCropBoxData({
            left: 0,
            top: 0,
            width: parent.width(),
            height: parent.height()
          });
          var containerData = this.cropper.getContainerData();

          const imageWidth = canvasData.naturalWidth;
          const imageHeight = canvasData.naturalHeight;
          let widthRatio = 1;
          let heightRatio = 1;
          let minPercent = 1;
          var width = parent.width();
          var height = parent.height();
          if (imageWidth > 0) {
            widthRatio = width / imageWidth;
            heightRatio = height / imageHeight;
            if (widthRatio <= heightRatio) {
              minPercent = heightRatio;
            } else {
              minPercent = widthRatio;
            }
          }
          const ratio = 1 + newData.zoom;
          const widthImage = Math.ceil(imageWidth * minPercent);
          this.cropper.zoomTo((widthImage * ratio) / imageWidth);
          this.cropper.scale(this.item.scaleX, 1);
        }

        if (newData.imageSrc != oldData.imageSrc) {
          this.cropper.replace(this.cropImageSrc);
        }
      }
    }
  },
  mounted: function () {
    this.initImageCanvas();
  },
  watch: {
    imageChanged: {
      handler: function (newData, oldData) {
        if (newData.ready) {
          this.initNewImage(newData, oldData);
        }
      }
    }
  }
});
